import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { Typography, Divider, Button, Grid, Container, TextField } from '@mui/material';
import axios from 'axios';
  
import AppContext from '../../components/AppContext';
import ErrorHandler from '../../components/ErrorHandler';
import Loading from '../../components/Loading';

import Config from '../../utils/Config';
import {TimestampToDate, TimestampToMillisNumber} from '../../utils/Helpers';

export default function View() {
  const navigate = useNavigate();
  const [queryParameters] = useSearchParams();
  const [data, setData] = useState(false);

  const { appContext } = React.useContext(AppContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(Config.BASE_URL + '/admin/insurances/get?id=' + queryParameters.get('id'), {
          headers: {
            Authorization: 'Bearer ' + appContext.userToken, 
            'Cache-Control': 'no-cache',
          },
        });

        setData(response.data);
      } catch (error) {
        console.error(error);
        ErrorHandler(error.response, {'userToken': appContext.userToken, 'signOut': appContext.signOut});
      }
    };

    fetchData();
  }, []);

    console.log(queryParameters.get('id'))

    console.log(data.length)
    console.log(data)
  
    if (data === false) {
      return (<Loading />);
    }

    if (!data) {
      return (
        <Container maxWidth="false" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 300 }}>
          <Typography variant="h4">Nema podataka</Typography>
        </Container>
      )
    }
  
    return (
      <>
      <Container maxWidth="false">
        <Grid container spacing={1} sx={{ my: 2 }}>
          <Typography variant="h4">Kasko polisa - {data.policyNumber}</Typography>
        </Grid>
        <Divider light />
        <Grid container spacing={1} sx={{ my: 1 }}>
          <Grid item xs={2} textAlign="left" sx={{ fontWeight: 'bold' }}>Vozilo:</Grid>
          <Grid item xs={3} textAlign="left">{data.car.garageNumber} - {data.car.registrationPlate} - {data.car.brand.name} {data.car.model}</Grid>
        </Grid>
        <Grid container spacing={1} sx={{ my: 1 }} className="FormRowOdd">
          <Grid item xs={2} textAlign="left" sx={{ fontWeight: 'bold' }}>Osiguravajuća kuća:</Grid>
          <Grid item xs={3} textAlign="left">{data.insuranceCompany.name}</Grid>
        </Grid>
        <Grid container spacing={1} sx={{ my: 1 }}>
          <Grid item xs={2} textAlign="left" sx={{ fontWeight: 'bold' }}>Broj polise:</Grid>
          <Grid item xs={3} textAlign="left">{data.policyNumber}</Grid>
        </Grid>
        <Grid container spacing={1} sx={{ my: 1 }} className="FormRowOdd">
          <Grid item xs={2} textAlign="left" sx={{ fontWeight: 'bold' }}>Obračunski period od:</Grid>
          <Grid item xs={3} textAlign="left">{TimestampToDate(data.accountingStartDate)}</Grid>
        </Grid>
        <Grid container spacing={1} sx={{ my: 1 }}>
          <Grid item xs={2} textAlign="left" sx={{ fontWeight: 'bold' }}>Obračunski period do:</Grid>
          <Grid item xs={3} textAlign="left">{TimestampToDate(data.accountingEndDate)}</Grid>
        </Grid>
      </Container>
      <Container maxWidth="false" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20, marginBottom: 20 }}>
        <Button variant="contained" color="success" sx={{mx: 1}} onClick={() => navigate('/insurances/edit?id=' + queryParameters.get('id'))}>Izmeni</Button>
        <Button variant="contained" color="primary" sx={{mx: 1}} onClick={() => navigate('/insurances/list')}>Nazad</Button>
      </Container>
      </>
    );
}